import preval from 'preval.macro'
import moment from 'moment'

const buildTimestamp = preval`module.exports = new Date().getTime();`
const build = moment(buildTimestamp).utc().format('YYYYMMDD-HHmmss')

export default build
